module.exports = __webpack_public_path__ + "img/icon_map_53_on_101.1bf060ef.png";